import {Platform, StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';
import {FONTS} from '../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    // Local replacement for the color-bearing CommonStyles.white_bg
    screenBackground: {
      backgroundColor: colors.background,
    },
    webcontainer: {
      maxWidth: 404,
      ...CommonStyles.br_16,
    },
    subcontainer: {
      flex: 1,
      backgroundColor: colors.surface,
    },
    topBorder24: {
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
    },
    webSubContainer: {
      paddingHorizontal: 24,
      paddingBottom: 20,
      borderBottomLeftRadius: 16,
      borderBottomRightRadius: 16,
    },
    container: {
      paddingHorizontal: 24,
      paddingBottom: 20,
    },
    headerView: {
      marginTop: 30,
      marginHorizontal: 24,
    },
    title: {
      fontFamily: FONTS.boldFont,
      fontSize: 24,
      fontWeight: '700',
      marginTop: 14,
      lineHeight: 36,
      color: colors.textPrimary,
    },
    subtitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 16,
      marginTop: Platform.OS === 'web' ? 12 : 5,
      lineHeight: 24,
      color: colors.textSecondary,
    },
    boldFont: {
      fontFamily: FONTS.boldFont,
    },
    overlayContainer: {
      ...CommonStyles.full_overlay,
      ...CommonStyles.full_screen_height,
      ...CommonStyles.flex_center,
      backgroundColor: colors.overlayLight,
    },
  });

export default makeStyles;
